import { all, takeLatest } from 'redux-saga/effects';
import { fetchWrapperFuncNoLoading } from '../../utils';
import { getPortletApi2, getSystemConfig } from '../System/systemConfig';
import { radioEinsSetWeeklyComment, RADIOEINS_LOAD_WEEKLY_COMMENT } from './actions';

function* loadWeeklyCommentGenerator() {
    yield* fetchWrapperFuncNoLoading(() => getPortletApi2().getWeeklyComment(getSystemConfig().clientName), [
        r => radioEinsSetWeeklyComment(r)
    ]);
}

function* watchForRadioEinsActions() {
    yield takeLatest(RADIOEINS_LOAD_WEEKLY_COMMENT, loadWeeklyCommentGenerator);
}

export function* radioEinsSagas() {
    yield all([watchForRadioEinsActions()]);
}
